import { IStore } from 'Store/.';
import { createSelector } from 'reselect';

const getIsFetching = (store: IStore) => store.skanetrafiken.isFetching;
const getLocationPoints = (store: IStore) => store.skanetrafiken.locationOptions;
const getTravelOptions = (store: IStore) => store.skanetrafiken.travelOptions;

export {
  getIsFetching,
  getLocationPoints,
  getTravelOptions,
};


// WEBPACK FOOTER //
// ./src/components/PickSkanetrafiken/Redux/selectors.tsx